/** @jsxImportSource @emotion/react */
import { useRef, useState } from "react";
import { ReactJSXElement } from "@emotion/react/types/jsx-namespace";
import { Controller, UseFieldArrayReturn, Control, UseFormRegister, FieldErrors } from "react-hook-form";
import { ResponseParamBase } from "../../common/Types";
import configcss from "../../css/config.module.css";
import { IFormInputs } from "../Config";
import { InputBase } from "@mui/material";

export const TextListEditType = {
    initMessage: "initMessageList",
    //ipAddress: "ipAddress",
} as const
export type TextListEditType = typeof TextListEditType[keyof typeof TextListEditType]

export type InitMessagesProp = {
    //editType: TextListEditType,
    messages: ArrayFieldRowType[],
    onChangeMessageList: (messages: ArrayFieldRowType[]) => void,
    control: Control<IFormInputs>,
    register: UseFormRegister<IFormInputs>,
    useFieldArrays: UseFieldArrayReturn<IFormInputs, TextListEditType>,
    errors: FieldErrors<IFormInputs>,
    //e2: Merge<FieldError, FieldErrorsImpl<IFormInputs>>,
}

export type ArrayFieldRowType = {
    msgtext: string,
}

type ResponseParam = ResponseParamBase & {

}

export const InitMessages = (prop: InitMessagesProp): ReactJSXElement => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const accordionRef = useRef(null);

    /*const {register, handleSubmit, trigger, control, getValues, watch, formState: { errors, isValid }} = useForm<IFormInputs>({
        defaultValues: {
            messages: prop.messages,
        },
        mode: "onSubmit",
        reValidateMode: "onSubmit",
        resolver: yupResolver(schema),
    });

    const {fields, append, remove, replace} = useFieldArray({
        name: "messages",
        control: control,
    });

    const onSubmit: SubmitHandler<IFormInputs> = async (data: IFormInputs, event?: BaseSyntheticEvent) => {
        const response = await UploadFile<ResponseParam>(
            ApiUrl.UpdateUserInitMessage,
            data,
            setIsLoading,
        ).then((response) => {
            prop.onChangeMessageList(fields)
        });
    }*/
    
    return(
        <>
        <div id={"Initmessage"} className={configcss['infoBox']}>
            <div className={`${configcss['infoBoxInner']} ${configcss['mdlBox']}`}>
                    {
                        prop.useFieldArrays.fields.map((field, index) => {
                            return(
                                <div key={index} className={configcss['infoBoxInner-sub']}>                                    
                                    <div style={{display: "flex", justifyContent: "flex-start", alignItems: "center", flexFlow: "row"}}>
                                    <Controller
                                        name={`initMessageList.${index}.msgtext`}
                                        control={prop.control}
                                        defaultValue={field.msgtext}
                                        render={({field}) => (
                                            <InputBase {...field} {...prop.register(`initMessageList.${index}.msgtext`)} multiline maxRows={5} className={configcss['infoTextArea']}></InputBase>
                                        )}
                                    />
                                    <input type="button" value="削除" className={configcss['infoBoxBtn']} style={{height: "40px"}} onClick={(e) => {
                                        prop.useFieldArrays.remove(index);
                                    }}></input>                                    
                                    </div>
                                    <div className={configcss['error']}>{prop.errors.initMessageList && prop.errors.initMessageList[index]?.msgtext?.message}</div>
                                </div>
                            )
                        })
                    }
                    <div className={`${configcss['infoBoxInner-sub']} ${configcss['layoutBox']}`}>
                        <input type="button" value="追加" className={configcss['infoBoxBtn']} onClick={(e) => {
                            prop.useFieldArrays.append({
                                msgtext: ""
                            });
                        }}></input>
                    </div>
            </div>
        </div>
        </>
    );
}